var exports = {
  "NI": "DefaultItemTitle__ITneTl",
  "UD": "DefaultItemTitleContainer__Wu0ri7",
  "CZ": "DefaultItemContent__KUJsdw",
  "PB": "CompactItemTitle__yY1FNj",
  "E5": "CompactItemTitleContainer__xmsh9I",
  "k4": "CompactItemLeadingContent__gXsyVh",
  "Go": "CompactWideItemDescription__okVMOf",
  "du": "CompactListItem__oOwoyl",
  "Xw": "CompactItemMetadataContainer__SMud9i",
  "W_": "RepoOwner__KFVLzb",
  "xb": "NwoTitle__r1hvr4",
  "bu": "CompactItemLanguageLabel__92haLE",
  "Ci": "CompactItemAttributes__62wqFf",
  "Wm": "CompactItemSettingsLink__83cETh",
  "T0": "FormattedDescription__JqeVHv",
  "p6": "LabelsContainer__Bi_rOW",
  "KS": "LastUpdated__Mhkqyc",
  "hl": "LastUpdatedNarrow__o5ORro",
  "P": "CompactNarrowItemContent__TVDiWZ",
  "T7": "CompactItemTypeLabel__AUCq7p",
  "A6": "TopicLabel__BukHTy",
  "Et": "MoreTopicsButton__1zaker",
  "Ns": "TopicsList__XBoKUv",
  "e3": "SmallScreenOnly__KktHod",
  "nQ": "HideOnSmallScreen__zMyWHa",
  "UA": "LanguageLabelContainer__aF5NzY",
  "OG": "TruncatedPrimaryLanguageName__vavjYZ",
  "ey": "PrimaryLanguageName__94OAQO",
  "sS": "IconLabel__xAiop0",
  "zw": "SparklineContainer__-9gI7J",
};

module.exports = exports;
